import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import { Toaster } from 'react-hot-toast';
import ScrollToTop from './utility/ScrollToTop.ts';
import { persistor, store } from './redux/store.ts';
import { PersistGate } from 'redux-persist/integration/react';
import { AuthProvider } from './context/AuthContext.tsx';

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <Toaster />
        <ScrollToTop />
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered:', registration.scope);
    })
    .catch((err) => console.error('Service Worker registration failed:', err));
}
